export const IconClose = ({ width = '32', height = '32', fill = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 22 22"
    >
      <g
        data-name="Rectangle 20409"
        style={{ stroke: 'transparent', fill: 'none' }}
      >
        <path style={{ stroke: 'none' }} d="M0 0h22v22H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h21v21H.5z" />
      </g>
      <path
        data-name="Close"
        d="M2.377 2.392a1.285 1.285 0 0 1 1.816 0l6.8 6.8 6.8-6.8a1.285 1.285 0 1 1 1.816 1.816l-6.8 6.8 6.8 6.8a1.285 1.285 0 0 1-1.816 1.816l-6.8-6.8-6.8 6.8a1.285 1.285 0 0 1-1.816-1.816l6.8-6.8-6.8-6.8a1.285 1.285 0 0 1 0-1.816z"
      />
    </svg>
  );
};

export const IconMember = ({ width = '32', height = '32', fill = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 22 22"
    >
      <g
        data-name="Rectangle 20409"
        style={{ stroke: 'transparent', fill: 'none' }}
      >
        <path style={{ stroke: 'none' }} d="M0 0h22v22H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h21v21H.5z" />
      </g>
      <path
        data-name="Member"
        d="M5.6 17.6v.6h1.2v-.6zm9.6 0v.6h1.2v-.6zm-8.4 0V17H5.6v.6zm3-3.6h2.4v-1.2H9.8zm5.4 3v.6h1.2V17zm-3-3a3 3 0 0 1 3 3h1.2a4.2 4.2 0 0 0-4.2-4.2zm-5.4 3a3 3 0 0 1 3-3v-1.2A4.2 4.2 0 0 0 5.6 17zM11 5.6a3 3 0 0 0-3 3h1.2A1.8 1.8 0 0 1 11 6.8zm3 3a3 3 0 0 0-3-3v1.2a1.8 1.8 0 0 1 1.8 1.8zm-3 3a3 3 0 0 0 3-3h-1.2a1.8 1.8 0 0 1-1.8 1.8zm0-1.2a1.8 1.8 0 0 1-1.8-1.8H8a3 3 0 0 0 3 3zm0 8.4A7.8 7.8 0 0 1 3.2 11H2a9 9 0 0 0 9 9zm7.8-7.8a7.8 7.8 0 0 1-7.8 7.8V20a9 9 0 0 0 9-9zM11 3.2a7.8 7.8 0 0 1 7.8 7.8H20a9 9 0 0 0-9-9zM11 2a9 9 0 0 0-9 9h1.2A7.8 7.8 0 0 1 11 3.2z"
      />
    </svg>
  );
};

export const IconCart = ({ width = '32', height = '32', fill = '' }) => {
  return (
    <svg
      data-name="Cart Medium"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 22 22"
    >
      <g
        data-name="Rectangle 20409"
        style={{ stroke: 'transparent', fill: 'none' }}
      >
        <path style={{ stroke: 'none' }} d="M0 0h22v22H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h21v21H.5z" />
      </g>
      <path d="M7.039 2.475a3.087 3.087 0 0 0-3.025 2.5l-.606 3.183h-.7a.71.71 0 0 0-.7.844l1.528 8.021a3.087 3.087 0 0 0 3.03 2.502h8.869a3.087 3.087 0 0 0 3.025-2.5l1.527-8.021a.711.711 0 0 0-.7-.844h-.7l-.601-3.185a3.087 3.087 0 0 0-3.025-2.5zm0 1.421h7.922a1.651 1.651 0 0 1 1.629 1.347l.555 2.915H4.855l.555-2.915a1.651 1.651 0 0 1 1.629-1.347zM3.566 9.575h.31a.712.712 0 0 0 .23 0h13.787a.711.711 0 0 0 .228 0h.311l-1.366 7.182a1.651 1.651 0 0 1-1.629 1.347H6.566a1.652 1.652 0 0 1-1.63-1.347zm3.385 1.411a.71.71 0 0 0-.686.8l.474 4.263a.711.711 0 1 0 1.412-.157l-.474-4.263a.711.711 0 0 0-.725-.642zm2.851 0a.711.711 0 0 0-.7.721v4.268a.711.711 0 1 0 1.421 0V11.71a.711.711 0 0 0-.722-.721zm2.369 0a.71.71 0 0 0-.7.721v4.268a.711.711 0 1 0 1.421 0V11.71a.711.711 0 0 0-.722-.721zm2.851 0a.71.71 0 0 0-.7.642l-.474 4.263a.711.711 0 1 0 1.412.157l.474-4.263a.711.711 0 0 0-.708-.8z" />
    </svg>
  );
};

export const IconCallCenter = ({ width = '32', height = '32', fill = '' }) => {
  return (
    <svg
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16 2C8.2804 2 2 8.2804 2 16V21.8002C2 23.2338 3.2558 24.4 4.8 24.4H6.2C6.5713 24.4 6.9274 24.2525 7.18995 23.99C7.4525 23.7274 7.6 23.3713 7.6 23V15.7998C7.6 15.4285 7.4525 15.0724 7.18995 14.8098C6.9274 14.5473 6.5713 14.3998 6.2 14.3998H4.9288C5.7072 8.9818 10.3692 4.8 16 4.8C21.6308 4.8 26.2928 8.9818 27.0712 14.3998H25.8C25.4287 14.3998 25.0726 14.5473 24.81 14.8098C24.5475 15.0724 24.4 15.4285 24.4 15.7998V24.4C24.4 25.9442 23.1442 27.2 21.6 27.2H18.8V25.8H13.2V30H21.6C24.6884 30 27.2 27.4884 27.2 24.4C28.7442 24.4 30 23.2338 30 21.8002V16C30 8.2804 23.7196 2 16 2Z" />
    </svg>
  );
};

export const IconImage = ({ width = '48', height = '48', fill = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 48 48"
    >
      <g style={{ opacity: '.16' }}>
        <g style={{ stroke: 'transparent', fill: 'none' }}>
          <path style={{ stroke: 'none' }} d="M0 0h48v48H0z" />
          <path style={{ fill: 'none' }} d="M.5.5h47v47H.5z" />
        </g>
        <path
          data-name="Image"
          d="M43.273 38.909V8.364A4.376 4.376 0 0 0 38.909 4H8.364A4.376 4.376 0 0 0 4 8.364v30.545a4.376 4.376 0 0 0 4.364 4.364h30.545a4.376 4.376 0 0 0 4.364-4.364zm-26.4-10.953 4.582 5.52 6.764-8.705a1.1 1.1 0 0 1 1.746.022L37.622 35a1.091 1.091 0 0 1-.873 1.745h-26.16a1.087 1.087 0 0 1-.851-1.767L15.171 28a1.076 1.076 0 0 1 1.702-.044z"
          transform="translate(.364 .364)"
          style={{ fill: '#333' }}
        />
      </g>
    </svg>
  );
};

export const IconUser = ({ width = '48', height = '48', fill = '' }) => {
  return (
    <svg
      data-name="User Account"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 72 72"
    >
      <g
        data-name="Rectangle 20616"
        style={{ stroke: 'transparent', fill: 'none' }}
      >
        <path style={{ stroke: 'none' }} d="M0 0h72v72H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h71v71H.5z" />
      </g>
      <g data-name="Group 24818">
        <path
          data-name="Path 25949"
          d="M16.314 30.6c-7.07 0-7.364-10.313-7.364-10.313V11.45h14.727v8.836S23.383 30.6 16.314 30.6z"
          transform="translate(19.689 26.023)"
          style={{ fill: '#f7c4cc' }}
        />
        <path
          data-name="Path 25950"
          d="M17.3 13.741a2.945 2.945 0 1 0-2.95-2.941 2.946 2.946 0 0 0 2.95 2.941z"
          transform="translate(31.962 17.842)"
          style={{ fill: '#f7c4cc' }}
        />
        <path
          data-name="Path 25951"
          d="M9.2 13.741A2.945 2.945 0 1 0 6.25 10.8a2.945 2.945 0 0 0 2.95 2.941z"
          transform="translate(13.552 17.842)"
          style={{ fill: '#f7c4cc' }}
        />
        <path
          data-name="Path 25952"
          d="M33.659 10.934c0-11.193-26.509-7.364-26.509 0v10.309a13.255 13.255 0 1 0 26.509 0z"
          transform="translate(15.598 8.869)"
          style={{ fill: '#ffdfe4' }}
        />
        <path
          data-name="Path 25953"
          d="M21.427 2C12.444 2 6.7 9.216 6.7 18.2v3.387l2.945 2.5v-7.36l17.673-5.891 5.891 5.891v7.364l2.945-2.5V18.2c0-5.891-1.473-11.782-8.836-13.255L25.846 2z"
          transform="translate(14.575 4.545)"
          style={{ fill: '#a5050d' }}
        />
        <path
          data-name="Path 25954"
          d="M14.023 11.245a1.473 1.473 0 1 0-1.473-1.472 1.473 1.473 0 0 0 1.473 1.472z"
          transform="translate(27.87 18.863)"
          style={{ fill: '#5a5a5a' }}
        />
        <path
          data-name="Path 25955"
          d="M10.422 11.245A1.473 1.473 0 1 0 8.95 9.773a1.473 1.473 0 0 0 1.472 1.472z"
          transform="translate(19.688 18.863)"
          style={{ fill: '#5a5a5a' }}
        />
        <path
          data-name="Path 25956"
          d="M34.927 14.15a10.677 10.677 0 0 1-14.727 0S4 17.1 4 33.3h47.127c0-16.2-16.2-19.15-16.2-19.15z"
          transform="translate(8.439 32.16)"
          style={{ fill: '#a5050d' }}
        />
      </g>
    </svg>
  );
};

export const IconAssistant = ({ width = '48', height = '48', fill = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 48 48"
    >
      <g
        data-name="Rectangle 20616"
        style={{ stroke: 'transparent', fill: 'none' }}
      >
        <path style={{ stroke: 'none' }} d="M0 0h48v48H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h47v47H.5z" />
      </g>
      <g data-name="Group 24817">
        <path
          data-name="Path 25940"
          d="M7.381 18.952a4.289 4.289 0 0 0 4.381-4.19 4.289 4.289 0 0 0-4.381-4.19A4.289 4.289 0 0 0 3 14.762a4.289 4.289 0 0 0 4.381 4.19z"
          transform="translate(0 12.38)"
          style={{ fill: '#f7c4cc' }}
        />
        <path
          data-name="Path 25941"
          d="M19.381 18.952a4.289 4.289 0 0 0 4.381-4.19 4.385 4.385 0 0 0-8.762 0 4.289 4.289 0 0 0 4.381 4.19z"
          transform="translate(18.667 12.38)"
          style={{ fill: '#f7c4cc' }}
        />
        <path
          data-name="Path 25942"
          d="M37.143 14.214c0-13.3-32.857-8.7-32.857 0v10.475c0 8.7 7.338 15.714 16.429 15.714s16.429-7.019 16.429-15.714z"
          transform="translate(2 5.597)"
          style={{ fill: '#ffdfe4' }}
        />
        <path
          data-name="Path 25943"
          d="M22.047 2.429c-10.3 0-18.619 7.962-18.619 17.809V23.8l2.19 1.676v-3.143l23-10.266 9.857 10.266v3.143l2.19-1.676v-3.562c.002-8.381-6.241-17.809-18.618-17.809z"
          transform="translate(.667 .619)"
          style={{ fill: '#a5050d' }}
        />
        <path
          data-name="Path 25944"
          d="M15.048 15.618a2.1 2.1 0 1 0-2.191-2.1 2.144 2.144 0 0 0 2.191 2.1z"
          transform="translate(15.334 13.617)"
          style={{ fill: '#5a5a5a' }}
        />
        <path
          data-name="Path 25945"
          d="M9.048 15.618a2.1 2.1 0 1 0 0-4.19 2.1 2.1 0 1 0 0 4.19z"
          transform="translate(6 13.617)"
          style={{ fill: '#5a5a5a' }}
        />
        <path
          data-name="Path 25946"
          d="M35.524 25.047a1.013 1.013 0 0 0-1.1 1.048v-7.333C34.429 9.543 26.543 2 16.9 2H9.238a1.013 1.013 0 0 0-1.1 1.048 1.013 1.013 0 0 0 1.1 1.052H16.9c8.433 0 15.334 6.6 15.334 14.666v10.472a1.1 1.1 0 0 0 2.19 0v2.1a7.459 7.459 0 0 1-7.667 7.333H14.714a1.049 1.049 0 1 0 0 2.1h12.048a9.61 9.61 0 0 0 9.857-9.428v-5.248a1.013 1.013 0 0 0-1.095-1.048z"
          transform="translate(8)"
          style={{ fill: '#5a5a5a' }}
        />
        <path
          data-name="Path 25947"
          d="M20.857 10.571h-1.1a2.151 2.151 0 0 0-2.191 2.1v4.19a2.151 2.151 0 0 0 2.191 2.1h1.1a2.151 2.151 0 0 0 2.19-2.1v-4.19a2.151 2.151 0 0 0-2.19-2.1z"
          transform="translate(22.667 12.38)"
          style={{ fill: '#333' }}
        />
        <path
          data-name="Path 25948"
          d="M12.048 20.762a2.1 2.1 0 1 0-2.19-2.1 2.145 2.145 0 0 0 2.19 2.1z"
          transform="translate(10.667 21.047)"
          style={{ fill: '#333' }}
        />
      </g>
    </svg>
  );
};

export const IconCartColor = ({ width = '48', height = '48', fill = '' }) => {
  return (
    <svg
      data-name="Cart color"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 72 72"
    >
      <path
        data-name="Path 24616"
        d="M61.593 24.871H7.4a2.356 2.356 0 0 0-2.36 2.356v3.535a2.356 2.356 0 0 0 2.36 2.356h.589v27.1a2.356 2.356 0 0 0 2.356 2.356h48.302A2.356 2.356 0 0 0 61 60.217v-27.1h.589a2.356 2.356 0 0 0 2.356-2.356v-3.534a2.356 2.356 0 0 0-2.356-2.356z"
        transform="translate(1.505 1.455)"
        style={{ fill: '#ffdfe4' }}
      />
      <path
        data-name="Path 24617"
        d="M13.649 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.771-1.178-1.771zM18.362 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.771-1.178-1.771zM23.074 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c.001-.98-.202-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c.001-.98-.202-1.771-1.178-1.771zM27.787 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.771-1.178-1.771zM32.5 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.771-1.178-1.771zM37.213 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.771-1.178-1.771zM41.925 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c-.003-.98-.203-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c-.003-.98-.203-1.771-1.178-1.771zM46.638 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.771-1.178-1.771zM51.351 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.771-1.178-1.771zM56.063 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c.001-.98-.201-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c.001-.98-.201-1.771-1.178-1.771z"
        transform="translate(1.144 .792)"
        style={{ fill: '#b5930c' }}
      />
      <path
        data-name="Path 24618"
        d="M8.136 60.641A2.356 2.356 0 0 0 10.492 63h23.541l27.121-27.1v-2.357H8.136z"
        transform="translate(1.354 1.033)"
        style={{ fill: '#f7c4cc' }}
      />
      <path
        data-name="Path 24619"
        d="M56.591 26.386a1.767 1.767 0 1 0 1.25.518 1.767 1.767 0 0 0-1.25-.518zm-43.591 0a1.767 1.767 0 1 0 1.25.518 1.767 1.767 0 0 0-1.25-.518zm37.42-2.356h6.491L41.07 8.191a2.295 2.295 0 1 0-3.245 3.245zm-31.247 0 12.591-12.593a2.3 2.3 0 0 0-3.245-3.245L12.681 24.03z"
        transform="translate(1.204 2.298)"
        style={{ fill: '#5a5a5a' }}
      />
      <path
        data-name="Path 24620"
        d="M13.649 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.771-1.178-1.771zM18.362 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.771-1.178-1.771zM23.074 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c.001-.98-.202-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c.001-.98-.202-1.771-1.178-1.771zM27.787 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.771-1.178-1.771zM32.5 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.771-1.178-1.771zM37.213 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.771-1.178-1.771zM41.925 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c-.003-.98-.203-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c-.003-.98-.203-1.771-1.178-1.771zM46.638 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.771-1.178-1.771zM51.351 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c0-.98-.202-1.771-1.178-1.771zM56.063 38.5c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c.001-.98-.201-1.767-1.178-1.767zm0 11.782c-.976 0-1.178.792-1.178 1.767v5.3c0 .976.2 1.767 1.178 1.767s1.178-.791 1.178-1.767v-5.3c.001-.98-.201-1.771-1.178-1.771z"
        transform="translate(1.144 .792)"
        style={{ fill: '#a5050d' }}
      />
      <g
        data-name="Rectangle 20627"
        style={{ stroke: 'transparent', fill: 'none' }}
      >
        <path style={{ stroke: 'none' }} d="M0 0h72v72H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h71v71H.5z" />
      </g>
    </svg>
  );
};

export const IconMoney = ({ width = '48', height = '48', fill = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 72 72"
    >
      <g
        data-name="Rectangle 20627"
        style={{ stroke: 'transparent', fill: 'none' }}
      >
        <path style={{ stroke: 'none' }} d="M0 0h72v72H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h71v71H.5z" />
      </g>
      <path
        data-name="Path 25961"
        d="M5.273 4A3.205 3.205 0 0 0 2 7.273V40a3.205 3.205 0 0 0 3.273 3.273h52.363A3.205 3.205 0 0 0 60.909 40V7.273A3.205 3.205 0 0 0 57.636 4z"
        transform="translate(4.545 12.091)"
        style={{ fill: '#ffdfe4' }}
      />
      <path
        data-name="Path 25962"
        d="M21.886 28.023A10.636 10.636 0 1 0 11.25 17.386a10.636 10.636 0 0 0 10.636 10.637z"
        transform="translate(25.568 18.341)"
        style={{ fill: '#f7c4cc' }}
      />
      <path
        data-name="Path 25963"
        d="M54.3 39.114H5.2a2.458 2.458 0 0 1-2.45-2.455V7.2A2.458 2.458 0 0 1 5.2 4.75h49.1a2.458 2.458 0 0 1 2.45 2.45v29.459a2.458 2.458 0 0 1-2.45 2.455zM5.2 6.386a.818.818 0 0 0-.818.818v29.455a.821.821 0 0 0 .818.818h49.1a.821.821 0 0 0 .818-.818V7.2a.818.818 0 0 0-.818-.818z"
        transform="translate(6.25 13.796)"
        style={{ fill: '#a5050d' }}
      />
      <path
        data-name="Path 25964"
        d="M9 4h13.091v39.374H9z"
        transform="translate(20.454 12.091)"
        style={{ fill: '#5a5a5a' }}
      />
      <path
        data-name="Path 25966"
        d="M16.564 21.256c0-4.875-8.989-4.557-8.989-7.5 0-1.425 1.363-2.121 2.944-2.121 2.659 0 3.132 1.708 4.336 1.708a1.132 1.132 0 0 0 1.264-1.143c0-1.4-2.121-2.458-4.155-2.824V8.029a1.525 1.525 0 1 0-3.05 0v1.4c-2.214.503-4.125 2.041-4.125 4.547 0 4.683 8.989 4.493 8.989 7.786 0 1.137-1.234 2.276-3.26 2.276-3.039 0-4.052-2.057-5.284-2.057a1.187 1.187 0 0 0-1.139 1.268c0 1.213 2.029 2.669 4.822 3.078v1.535a1.527 1.527 0 0 0 3.05 0v-1.529a.377.377 0 0 0-.01-.046c2.512-.47 4.608-2.1 4.608-5.032z"
        transform="translate(9.306 17.782)"
        style={{ fill: '#a5050d' }}
      />
    </svg>
  );
};

export const IconPrices = ({ width = '48', height = '48', fill = '' }) => {
  return (
    <svg
      data-name="User Account"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 72 72"
    >
      <g
        data-name="Rectangle 20616"
        style={{ stroke: 'transparent', fill: 'none' }}
      >
        <path style={{ stroke: 'none' }} d="M0 0h72v72H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h71v71H.5z" />
      </g>
      <g data-name="Group 24819">
        <path
          data-name="Path 25957"
          d="M51.924 41.171c-.979-10.829-6.379-16.262-6.379-16.262l-9.818-13.091H22.636l-9.818 13.091a22.675 22.675 0 0 0-4.2 7 8.124 8.124 0 0 0-2.985 13.708 8.055 8.055 0 0 0 3.544 11.129 8.514 8.514 0 0 0 6.914 4.163h26.182c2.257 0 5.519-1.275 7.655-5.416a8.142 8.142 0 0 0 2-14.321zM29.182 11.818a4.847 4.847 0 0 0 2.455-.681 4.856 4.856 0 0 0 2.455.681c2.711 0 6.545-3.836 6.545-6.545A3.205 3.205 0 0 0 37.364 2c-1.289 0-1.636 1.636-3.273 1.636S32.455 2 29.182 2s-3.273 1.636-4.909 1.636S22.291 2 21 2a3.205 3.205 0 0 0-3.273 3.273c0 2.71 3.836 6.545 6.545 6.545a4.856 4.856 0 0 0 2.455-.681 4.856 4.856 0 0 0 2.455.681z"
          transform="translate(6.818 4.545)"
          style={{ fill: '#f7c4cc' }}
        />
        <path
          data-name="Path 25958"
          d="M27.636 6.136A1.636 1.636 0 0 1 26 7.773H9.636a1.636 1.636 0 0 1 0-3.273H26a1.636 1.636 0 0 1 1.636 1.636z"
          transform="translate(18.182 10.227)"
          style={{ fill: '#5a5a5a' }}
        />
        <path
          data-name="Path 25959"
          d="M27.475 29.66c0-7.326-14.042-6.848-14.042-11.268 0-2.14 2.129-3.186 4.6-3.186 4.153 0 4.893 2.567 6.773 2.567a1.739 1.739 0 0 0 1.972-1.712c0-2.1-3.312-3.692-6.488-4.241V9.791a2.383 2.383 0 0 0-4.762 0v2.1c-3.463.758-6.442 3.068-6.442 6.833 0 7.035 14.038 6.75 14.038 11.692 0 1.713-1.928 3.425-5.091 3.425-4.747 0-6.328-3.091-8.255-3.091A1.814 1.814 0 0 0 8 32.654c0 1.821 3.171 4.011 7.532 4.621v2.304a2.384 2.384 0 0 0 4.763 0v-2.287c0-.028-.013-.049-.015-.074 3.924-.7 7.2-3.161 7.2-7.558z"
          transform="translate(18.181 17.045)"
          style={{ fill: '#a5050d' }}
        />
      </g>
    </svg>
  );
};

export const IconFacebook = ({ width = '48', height = '48', fill = '' }) => {
  return (
    <svg
      data-name="Group 24826"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 40 40"
    >
      <path
        data-name="Rectangle 21843"
        style={{ fill: 'none' }}
        d="M0 0h40v40H0z"
      />
      <path
        data-name="Icon awesome-facebook"
        d="M33.29 16.97a16.364 16.364 0 1 0-18.92 16.209V21.713h-4.158V16.97h4.157v-3.615c0-4.112 2.441-6.383 6.181-6.383a25.118 25.118 0 0 1 3.663.32v4.036h-2.064a2.368 2.368 0 0 0-2.666 2.562v3.08h4.538l-.721 4.743h-3.817v11.466A16.4 16.4 0 0 0 33.29 16.97z"
        transform="translate(3.074 3.074)"
        style={{ fill: '#1877f2' }}
      />
    </svg>
  );
};

export const IconCall = ({ width = '48', height = '48', fill = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 32 32"
    >
      <g
        data-name="Rectangle 20627"
        style={{ stroke: 'transparent', fill: 'none' }}
      >
        <path style={{ stroke: 'none' }} d="M0 0h32v32H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h31v31H.5z" />
      </g>
      <path
        d="M5.786 2.1A1.073 1.073 0 0 0 4.179 2L2.541 3.642a2.717 2.717 0 0 0-.712 2.8 27.815 27.815 0 0 0 6.6 10.462 27.817 27.817 0 0 0 10.462 6.6 2.717 2.717 0 0 0 2.8-.712l1.637-1.637a1.073 1.073 0 0 0-.1-1.607l-3.653-2.84a1.073 1.073 0 0 0-.918-.193l-3.467.866a2.763 2.763 0 0 1-2.624-.727L8.68 12.765a2.763 2.763 0 0 1-.728-2.624l.868-3.467a1.073 1.073 0 0 0-.193-.918zM2.983.809a2.763 2.763 0 0 1 4.136.258l2.84 3.651a2.762 2.762 0 0 1 .5 2.365l-.866 3.467a1.073 1.073 0 0 0 .282 1.018l3.89 3.89a1.073 1.073 0 0 0 1.02.282l3.466-.866a2.763 2.763 0 0 1 2.365.5l3.651 2.84a2.762 2.762 0 0 1 .258 4.134l-1.637 1.637a4.4 4.4 0 0 1-4.556 1.115 29.5 29.5 0 0 1-11.1-7A29.5 29.5 0 0 1 .235 7a4.4 4.4 0 0 1 1.113-4.554L2.985.809z"
        transform="translate(3.334 3.334)"
        style={{ fill: '#a5050d' }}
      />
    </svg>
  );
};

export const IconChevronDown = ({ width = '32', height = '32', fill = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 22 22"
    >
      <path d="M10.989 14.494a1 1 0 0 1-.639-.23L4.36 9.273a1 1 0 1 1 1.275-1.537l5.354 4.471 5.346-4.311a1.026 1.026 0 1 1 1.272 1.611l-5.99 4.822a1 1 0 0 1-.628.165z" />
    </svg>
  );
};

export const IconSuccess = ({ width = '32', height = '32', fill = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 72 72"
    >
      <path
        data-name="Success"
        d="M33.914 4.5a29.414 29.414 0 1 1-20.8 8.615 29.414 29.414 0 0 1 20.8-8.615zM30.25 39.717l-6.534-6.538a2.523 2.523 0 1 0-3.568 3.568l8.32 8.32a2.513 2.513 0 0 0 3.568 0l17.228-17.233a2.521 2.521 0 1 0-3.564-3.568z"
        transform="translate(2.036 2.135)"
        style={{ fill: '#92bd66' }}
      />
      <g
        data-name="Rectangle 20625"
        style={{ stroke: 'transparent', fill: 'none' }}
      >
        <path style={{ stroke: 'none' }} d="M0 0h72v72H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h71v71H.5z" />
      </g>
    </svg>
  );
};

export const IconError = ({ width = '32', height = '32', fill = '' }) => {
  return (
    <svg
      data-name="Component 97 – 2"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 56 56"
    >
      <g
        data-name="Rectangle 20410"
        style={{ stroke: 'transparent', fill: 'none' }}
      >
        <path style={{ stroke: 'none' }} d="M0 0h56v56H0z" />
        <path style={{ fill: 'none' }} d="M.5.5h55v55H.5z" />
      </g>
      <path
        d="M25.716 2.623a3.235 3.235 0 0 0-5.612 0L.472 36.027a3.341 3.341 0 0 0 2.806 5.059H42.54a3.341 3.341 0 0 0 2.806-5.059zM22.9 12.455a2.589 2.589 0 0 1 2.581 2.845l-1 10.041a1.58 1.58 0 0 1-3.149 0l-1-10.041a2.591 2.591 0 0 1 2.568-2.845zm.006 17.179a2.863 2.863 0 1 1-2.859 2.866 2.863 2.863 0 0 1 2.863-2.866z"
        transform="translate(5.091 6.644)"
        style={{ fill: '#ff9d00' }}
      />
    </svg>
  );
};
